<script setup lang="ts">
// import TopBarSection from '@/components/topbar-section/TopBarSection.component.vue'
// import FooterSection from '@/components/footer-section/FooterSection.component.vue'
// import { useThemeStore } from '@/components/theme-selector/themes-store'
// onMounted(() => {
//   if (import.meta.client && document) {
//     useThemeStore().restoreTheme()
//   }
// })
</script>

<template>
  <div
    class="relative flex flex-col w-full flex-grow"
    style="scroll-behavior: smooth; scroll-snap-type: y proximity"
  >
    <ClientOnly>
      <noscript>
        <strong
          >We're sorry but this website doesn't work properly without JavaScript enabled. Please enable it to
          continue.</strong
        >
      </noscript>
    </ClientOnly>
    <NuxtPage />
  </div>
</template>
